import styled, { x } from "@xstyled/styled-components";

import { Button, Text } from "@otta/design";
import { Icon } from "@otta/icons";

const ButtonWrapper = styled(Button).attrs({
  size: "small",
  level: "secondary",
  type: "button",
})`
  display: flex;
  gap: sm;
  max-width: fit-content;
  padding-left: sm;
  padding-right: sm;
  border-radius: xxl;
`;

export const AddButton = ({
  children,
  onClick,
  isOptional = false,
}: {
  children: React.ReactNode;
  onClick: () => void;
  isOptional?: boolean;
}) => {
  return (
    <ButtonWrapper onClick={onClick}>
      <Icon icon="plus" />
      <Text size={-1} bold>
        {children}
      </Text>
      {isOptional && <x.em fontWeight="normal">optional</x.em>}
    </ButtonWrapper>
  );
};
